import { ProColumns } from "@ant-design/pro-components"
import { FaInfoCircle } from 'react-icons/fa'
import { ProductionPlanningReport } from "services/productionPlanning_services"
import { formatNumber, sFormatNumber } from "utils/formatHelper"

export const defaultInitColumn = ({
  onShow,
  setCurrentList
}:
  { onShow: () => void, setCurrentList: React.Dispatch<React.SetStateAction<any[]>> }
) => {
  const defaultColumn: ProColumns<ProductionPlanningReport>[] = [
    //Stt
    {
      title: "STT",
      dataIndex: "stt",
      key: "stt",
      width: 60,
      fixed: "left",
      align: 'center'
    },
    // Khách hàng
    {
      title: "Khách hàng",
      dataIndex: "khachHang",
      key: "khachHang",
      width: 200,
      fixed: "left",
      ellipsis: true,
    },
    // Tên tp/btp
    {
      title: "Tên TP/BTP",
      dataIndex: "tenTPBTP",
      key: "tenTPBTP",
      width: 250,
      className: "!py-1",
      fixed: "left",
      ellipsis: true
    },
    // Mã tp/btp
    {
      title: "Mã TP/BTP",
      dataIndex: "maTPBTP",
      key: "maTPBTP",
      width: 150,
    },
    // Kích thước SP
    {
      title: "Kích thước SP",
      dataIndex: "kichThuocSanPham",
      key: "kichThuocSanPham",
      width: 150,
    },
    // Nhóm sản phẩm
    {
      title: "Nhóm sản phẩm",
      dataIndex: "nhomSanPham",
      key: "nhomSanPham",
      width: 150,
    },
    // Sản phẩm (tái bản/ lần đầu)
    {
      title: "Sản phẩm\n(tái bản/ lần đầu)",
      dataIndex: "sanPhamTBLD",
      key: "sanPhamTBLD",
      width: 200,
      className: "!py-1 whitespace-pre-line",
    },
    // Loại LSX (Loại lệnh sản xuất)
    {
      title: "Loại lệnh sản xuất",
      dataIndex: "loaiLSX",
      key: "loaiLSX",
      width: 100,
      sorter: true,
    },
    // Số WO
    {
      title: "Số WO",
      dataIndex: "soWO",
      key: "soWO",
      width: 100,
    },
    // Ngày ban hành WO
    {
      title: "Ngày ban hành WO",
      dataIndex: "ngayBanHanhWO",
      key: "ngayBanHanhWO",
      width: 200,
      sorter: true,
      valueType: "dateTime",
      fieldProps: {
        format: "DD/MM/YYYY HH:mm:ss",
      },
    },
    // Trạng thái WO
    {
      title: "Trạng thái WO",
      dataIndex: "trangThaiWO",
      key: "trangThaiWO",
      width: 150,
    },
    // Ngày y/c nhập kho theo SO
    {
      title: "Ngày y/c nhập kho",
      dataIndex: "ngayYeuCauGiaoHangTheoSO",
      key: "ngayYeuCauGiaoHangTheoSO",
      width: 200,
      align: 'center',
      valueType: "dateTime",
      fieldProps: {
        format: "DD/MM/YYYY",
      },
    },
    // // Ngayf y/c nhập kho
    // {
    //   title: "Ngày y/c nhập kho (Theo Kế Hoạch)",
    //   dataIndex: "ngayYeuCauNhapKho",
    //   key: "ngayYeuCauNhapKho",
    //   className: "!py-1 whitespace-pre-line",
    //   width: 200,
    //   align: 'center',
    //   valueType: "dateTime",
    //   fieldProps: {
    //     format: "DD/MM/YYYY HH:mm:ss",
    //   },
    // },
    // Số lượng WO
    {
      title: "S.Lượng WO\n(sản phẩm)",
      className: "!py-1 whitespace-pre-line",
      dataIndex: "soLuongWO",
      key: "soLuongWO",
      width: 130,
      valueType: "money",
      fieldProps: {
        moneySymbol: false,
        precision: 0,
      },
      onCell: () => ({
        style: {
          textAlign: 'right'
        }
      }),
    },
    // Số lượng cần sản xuất của công đoạn
    {
      title: 'Số lượng cần sản xuất của công đoạn',
      key: 'slSXCuaCongDoan',
      width: 250,
      children: [
        // Số lượng cần sx (tờ)
        {
          title: 'S.Lượng cần sản xuất\n(tờ)',
          key: 'soLuongCanSanXuatTo',
          dataIndex: 'soLuongCanSanXuatTo',
          width: 150,
          onCell: () => ({
            style: {
              textAlign: 'right'
            }
          }),
          render: (text: any) => sFormatNumber(Number(text)),
        },
        // Số sản phẩm/1 tờ/ 1 CĐ
        {
          title: 'Số sản phẩm/1 tờ/ 1 CĐ',
          key: 'soSanPham1To1CD',
          dataIndex: 'soSanPham1To1CD',
          width: 150,
          onCell: () => ({
            style: {
              textAlign: 'right'
            }
          }),
          render: (text: any) => sFormatNumber(Number(text)),
        },
        // S.lượng cần sản xuất(sản phẩm)
        {
          title: 'S.lượng cần sản xuất(sản phẩm)',
          key: 'soLuongCanSanXuatSanPham',
          dataIndex: 'soLuongCanSanXuatSanPham',
          width: 150,
          onCell: () => ({
            style: {
              textAlign: 'right'
            }
          }),
          render: (text: any) => sFormatNumber(Number(text)),
        },
      ]
    },
    // Loại NVL
    {
      title: 'Loại NVL',
      key: 'loaiNVL',
      dataIndex: "loaiNVL",
      width: 150,
    },
    // Khổ NVL
    {
      title: 'Khổ NVL',
      key: 'khoNVL',
      dataIndex: "khoNVL",
      width: 150,
    },
    // Qui cách in
    {
      title: 'Qui cách in',
      key: 'quyCachIn',
      dataIndex: "quyCachIn",
      width: 150,
    },
    // Thông số màu
    {
      title: 'Thông số màu',
      key: 'thongSoMau',
      dataIndex: "thongSoMau",
      width: 150,
    },
    // Mã màu pha
    {
      title: 'Mã màu pha',
      key: 'maMauPha',
      dataIndex: "maMauPha",
      width: 150,
    },
    // Công đoạn sản xuất
    {
      title: 'Công đoạn sản xuất',
      key: 'congDoanSanXuat',
      dataIndex: "congDoanSanXuat",
      width: 200,
      render: (value, record) => (
        <div className='flex gap-2 justify-between'>
          <div>
            <span className='font-semibold'>
              {record.congDoanSanXuat}
            </span>
          </div>
          <div onClick={() => {
            onShow()
            setCurrentList(record?.equipments || [])
          }} className='cursor-pointer' style={{
            display: record.isYellow ? 'block' : 'none'
          }}><FaInfoCircle
              style={{
                color: record.isYellow ? '#fb5607' : '#000'
              }}
              className='text-lg' /></div>
        </div>
      ),
    },
    // Máy/chuyền sản xuất
    {
      title: 'Máy/chuyền sản xuất',
      key: 'mayChuyenSanXuat',
      dataIndex: "mayChuyenSanXuat",
      width: 150,
    },

    // TG bắt đầu sản xuất (kế hoạch)
    {
      title: 'TG bắt đầu sản xuất\n(kế hoạch)',
      key: 'tgBatDauKH',
      className: "!py-1 whitespace-pre-line",
      width: 150,
      children: [
        {
          title: 'Ngày',
          key: 'thoiGianBatDauSanXuatKeHoach',
          dataIndex: 'thoiGianBatDauSanXuatKeHoach',
          width: 150,
          onCell: () => ({
            style: {
              textAlign: 'center'
            }
          }),
          valueType: "dateTime",
          fieldProps: {
            format: "DD/MM/YYYY",
          },
        },
        {
          title: 'Giờ',
          key: 'gioBatDauSanXuatKeHoach',
          dataIndex: 'thoiGianBatDauSanXuatKeHoach',
          width: 150,
          onCell: () => ({
            style: {
              textAlign: 'center'
            }
          }),
          valueType: "dateTime",
          fieldProps: {
            format: "HH:mm",
          },
        },
      ]
    },
    // TG kết thúc (kế hoạch)
    {
      title: 'TG kết thúc\n(kế hoạch)',
      key: 'tgKetThucKH',
      className: "!py-1 whitespace-pre-line",
      width: 150,
      children: [
        {
          title: 'Ngày',
          key: 'thoiGianKetThucSanXuatKeHoach',
          dataIndex: 'thoiGianKetThucSanXuatKeHoach',
          width: 150,
          onCell: () => ({
            style: {
              textAlign: 'center'
            }
          }),
          valueType: "dateTime",
          fieldProps: {
            format: "DD/MM/YYYY",
          },
        },
        {
          title: 'Giờ',
          key: 'gioKetThucSanXuatKeHoach',
          dataIndex: 'thoiGianKetThucSanXuatKeHoach',
          width: 150,
          onCell: () => ({
            style: {
              textAlign: 'center'
            }
          }),
          valueType: "dateTime",
          fieldProps: {
            format: "HH:mm",
          },
        },
      ]
    },
    // Thời gian bắt đầu canh máy
    // {
    //   title: 'TG bắt đầu\nCanh máy',
    //   key: 'tgBatDauCM',
    //   className: "!py-1 whitespace-pre-line",
    //   width: 150,
    //   children: [
    //     {
    //       title: 'Ngày',
    //       key: 'thoiGianBatDauCanhMay',
    //       dataIndex: 'thoiGianBatDauCanhMay',
    //       width: 150,
    //       onCell: () => ({
    //         style: {
    //           textAlign: 'center'
    //         }
    //       }),
    //       valueType: "dateTime",
    //       fieldProps: {
    //         format: "DD/MM/YYYY",
    //       },
    //     },
    //     {
    //       title: 'Giờ',
    //       key: 'GioBatDauCanhMay',
    //       dataIndex: 'thoiGianBatDauCanhMay',
    //       width: 150,
    //       onCell: () => ({
    //         style: {
    //           textAlign: 'center'
    //         }
    //       }),
    //       valueType: "dateTime",
    //       fieldProps: {
    //         format: "HH:mm",
    //       },
    //     },
    //   ]
    // },
    // Thời gian kết thúc canh máy
    // {
    //   title: 'TG kết thúc\nCanh máy',
    //   key: 'tgKetThucCM',
    //   className: "!py-1 whitespace-pre-line",
    //   width: 150,
    //   children: [
    //     {
    //       title: 'Ngày',
    //       key: 'thoiGianKetThucCanhMay',
    //       dataIndex: 'thoiGianKetThucCanhMay',
    //       width: 150,
    //       onCell: () => ({
    //         style: {
    //           textAlign: 'center'
    //         }
    //       }),
    //       valueType: "dateTime",
    //       fieldProps: {
    //         format: "DD/MM/YYYY",
    //       },
    //     },
    //     {
    //       title: 'Giờ',
    //       key: 'GioKetThucCanhMay',
    //       dataIndex: 'thoiGianKetThucCanhMay',
    //       width: 150,
    //       onCell: () => ({
    //         style: {
    //           textAlign: 'center'
    //         }
    //       }),
    //       valueType: "dateTime",
    //       fieldProps: {
    //         format: "HH:mm",
    //       },
    //     },
    //   ]
    // },
    // TG bắt đầu sản xuất (ghi nhận thực tế)
    {
      title: 'TG bắt đầu sản xuất\n(ghi nhận thực tế)',
      key: 'tgBatDauTT',
      className: "!py-1 whitespace-pre-line",
      width: 150,
      children: [
        {
          title: 'Ngày',
          key: 'thoiGianBatDauSanXuatThucTe',
          dataIndex: 'thoiGianBatDauSanXuatThucTe',
          width: 150,
          onCell: () => ({
            style: {
              textAlign: 'right'
            }
          }),
          valueType: "dateTime",
          fieldProps: {
            format: "DD/MM/YYYY",
          },
        },
        {
          title: 'Giờ',
          key: 'gioBatDauSanXuatThucTe',
          dataIndex: 'thoiGianBatDauSanXuatThucTe',
          width: 150,
          onCell: () => ({
            style: {
              textAlign: 'right'
            }
          }),
          valueType: "dateTime",
          fieldProps: {
            format: "HH:mm:ss",
          },
        },
      ]
    },
    // TG kết thúc (ghi nhận thực tế)
    {
      title: 'TG kết thúc\n(ghi nhận thực tế)',
      key: 'tgKetThucTT',
      className: "!py-1 whitespace-pre-line",
      width: 150,
      children: [
        {
          title: 'Ngày',
          key: 'thoiGianKetThucSanXuatThucTe',
          dataIndex: 'thoiGianKetThucSanXuatThucTe',
          width: 150,
          onCell: () => ({
            style: {
              textAlign: 'center'
            }
          }),
          valueType: "dateTime",
          fieldProps: {
            format: "DD/MM/YYYY",
          },
        },
        {
          title: 'Giờ',
          key: 'gioKetThucSanXuatThucTe',
          dataIndex: 'thoiGianKetThucSanXuatThucTe',
          width: 150,
          onCell: () => ({
            style: {
              textAlign: 'center'
            }
          }),
          valueType: "dateTime",
          fieldProps: {
            format: "HH:mm:ss",
          },
        },
      ]
    },
    // Tổng thời gian hoàn thành CĐSX (theo định mức)
    {
      title: 'Tổng thời gian hoàn thành CĐSX (theo định mức)',
      key: 'tgHoanThanhCDSXDM',
      className: "!py-1 whitespace-pre-line",
      width: 150,
      children: [
        {
          title: 'TG chuẩn bị\n(Phút)',
          key: 'tgDinhMucChuanBi',
          className: "!py-1 whitespace-pre-line",
          dataIndex: 'tgDinhMucChuanBi',
          width: 150,
          onCell: () => ({
            style: {
              textAlign: 'right'
            }
          }),
          render: (text) => text === "-" ? text : formatNumber(Number(text), 0),
        },
        {
          title: 'TG canh máy\n(Phút)',
          key: 'tgDinhMucCanhMay',
          className: "!py-1 whitespace-pre-line",
          dataIndex: 'tgDinhMucCanhMay',
          width: 150,
          onCell: () => ({
            style: {
              textAlign: 'right'
            }
          }),
          render: (text) => text === "-" ? text : formatNumber(Number(text), 0),
        },
        {
          title: 'TG sản xuất\n(Phút)',
          key: 'tgDinhMucSanXuat',
          className: "!py-1 whitespace-pre-line",
          dataIndex: 'tgDinhMucSanXuat',
          width: 150,
          onCell: () => ({
            style: {
              textAlign: 'right'
            }
          }),
          render: (text) => text === "-" ? text : formatNumber(Number(text), 0),
        },
        {
          title: 'Tổng TG SXCĐ\n(Phút)',
          key: 'tongThoiDinhMucGianSanXuatCongDoan',
          className: "!py-1 whitespace-pre-line",
          dataIndex: 'tongThoiDinhMucGianSanXuatCongDoan',
          width: 150,
          onCell: () => ({
            style: {
              textAlign: 'right'
            }
          }),
          render: (text) => text === "-" ? text : formatNumber(Number(text), 0),
        },
      ]
    },
    // Tổng thời gian hoàn thành CĐSX (theo thực tế )
    {
      title: 'Tổng thời gian hoàn thành CĐSX\n(theo thực tế )',
      key: 'tgHoanThanhCDSXTT',
      className: "!py-1 whitespace-pre-line",
      width: 150,
      children: [
        {
          title: 'TG chuẩn bị\n(Phút)',
          key: 'tgThucTeChuanBi',
          className: "!py-1 whitespace-pre-line",
          dataIndex: 'tgThucTeChuanBi',
          width: 150,
          onCell: () => ({
            style: {
              textAlign: 'right'
            }
          }),
          render: (text) => text === "-" ? text : formatNumber(Number(text), 0),
        },
        {
          title: 'TG canh máy\n(Phút)',
          key: 'tgThucTeCanhMay',
          className: "!py-1 whitespace-pre-line",
          dataIndex: 'tgThucTeCanhMay',
          width: 150,
          onCell: () => ({
            style: {
              textAlign: 'right'
            }
          }),
          render: (text) => text === "-" ? text : formatNumber(Number(text), 0),
        },
        {
          title: 'TG sản xuất\n(Phút)',
          key: 'tgThucTeSanXuat',
          className: "!py-1 whitespace-pre-line",
          dataIndex: 'tgThucTeSanXuat',
          width: 150,
          onCell: () => ({
            style: {
              textAlign: 'right'
            }
          }),
          render: (text) => text === "-" ? text : formatNumber(Number(text), 0),
        },
        {
          title: 'Tổng TG SXCĐ\n(Phút)',
          key: 'tongThoiThucTeGianSanXuatCongDoan',
          className: "!py-1 whitespace-pre-line",
          dataIndex: 'tongThoiThucTeGianSanXuatCongDoan',
          width: 150,
          onCell: () => ({
            style: {
              textAlign: 'right'
            }
          }),
          render: (text) => text === "-" ? text : formatNumber(Number(text), 0),
        },
      ]
    },
    // Chênh lệch TG giữa thực tế/kế hoạch (Phút)
    {
      title: 'Chênh lệch TG giữa thực tế/kế hoạch\n(Phút)',
      key: 'chenhLech',
      dataIndex: 'chenhLech',
      width: 200,
      onCell: () => ({
        style: {
          textAlign: 'right'
        }
      }),
      render: (text) => text === "-" ? text : formatNumber(Number(text), 0),
    }
  ]

  return { defaultColumn }
}